import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading, isUltraAuth } = useAuth(); // Add isUltraAuth

  if (loading) {
    // You can return a loading spinner here if you want
    return <div>Loading...</div>;
  }

  // If not logged in with Google, or not ultra authenticated, redirect to login
  if (!currentUser || !isUltraAuth) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
